import React from "react";

import AibleStep from "containers/CreateWizard/AibleStep";
import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";

export default class MarketplaceTitle extends React.PureComponent {
  render() {
    const { updateName, name } = this.props;
    return (
      <AibleStep message={"What would you like to title this blueprint on the marketplace?"} isBreak>
        <div className={styles.nameInput}>
          <div className={styles.inputWrapper}>
            <LineInput
              placeholder={"Enter name"}
              onChange={(val) => updateName(val)}
              isBox
              isHeader
              isMediumBox
              defaultValue={name}
            />
          </div>
        </div>
      </AibleStep>
    );
  }
}
